import React, { useState, useRef, useEffect } from 'react';
import { checkUserAuth } from '../firebase';
import { addDoc, collection } from "firebase/firestore";
import Cookies from 'js-cookie';
import './header.css';
import { AiOutlineHome, AiFillHome } from "react-icons/ai";
import { SlCalculator } from "react-icons/sl";
import { RiRobot2Line, RiRobot2Fill } from "react-icons/ri";
import { MdApps, MdBusinessCenter, MdOutlineBusinessCenter, MdSettings, MdSearch, MdCalculate, MdAccountBox, MdAccessibility, MdLabelOutline, MdSave, MdOutlineFavoriteBorder } from "react-icons/md";
import { IoSearchOutline } from "react-icons/io5";
import { CiCalculator2 } from "react-icons/ci";
import { GrUserNew } from "react-icons/gr";
import { useNavigate, useLocation } from "react-router-dom";
import html2canvas from 'html2canvas';
import { RiUserCommunityFill, RiUserCommunityLine } from "react-icons/ri";
import { RiAccountCircleLine } from "react-icons/ri";
import { BiLogIn } from 'react-icons/bi';
import Logo from '../assets/viabig_logo.png';
import Photosicon from '../assets/photos_icon.png';
import { MdNightsStay, MdOutlineLightMode } from "react-icons/md";
import Messageshow from '../message_root/message-show';
import Chartshow from '../cart_root/cart-show';
export default function Bot() {
    const navigate = useNavigate();
    const location = useLocation();

    const [user, setUser] = useState(null);
    const [notification, setnotification] = useState(0);
    const [pricehistorydata, setpricehistorydata] = useState([]);
    const [photoURL, setPhotoURL] = useState("");
    const [loginName, setLoginName] = useState("");
    // Automatically check for logged-in user on page load
    const [isOpen, setIsOpen] = useState(true);
    const [guid, setguid] = useState('');
    //login
    const [userlogin, setuserlogin] = useState(false); // State for popup
    const popupRef = useRef(null);    // Ref for direct DOM manipulation
    const [search, setSearch] = useState(null);
    //prod  
    useEffect(() => {
        checkUserAuth(setUser);  // Auto-login
        const existingUser = Cookies.get("sessiontoken");   // Check for existing login
        setguid(Cookies.get("guid"));
        if (existingUser != null) {
            setuserlogin(true);
        } else {
            setuserlogin(false);   // Auto-open login popup if not logged in
        }
    }, []);
    const create_search = async (e) => {
        if (search == null || search.trim() === "") {
            return; // Exit if search is null or empty
        }
        navigate("/search?id=" + encodeURIComponent(search.trim()));
    };
    const enter_search = async (e) => {
        if (search == null || search.trim() === "") {
            return; // Exit if search is null or empty
        }
        if (e.key === "Enter") {
            navigate("/search?id=" + encodeURIComponent(search.trim()));
        }
    };

    return (
        <div className="header">
            <div className='header_size'>

                <div className="left_body">
                    <div className="logo-div" onClick={() => navigate('/')}>
                        {/* <img src={Logo} alt="Logo" className="brand-logo" />  */}
                        <div className='logo-name'>VIABIG<a className='logo-name-sub'></a>

                        </div>
                    </div>
                </div>
                <div className='menus_body'>
                    <div
                        onClick={() => navigate('/')}
                        className={`menubutton-icon ${location.pathname === '/' ? 'active' : ''}`}
                        title="Home"
                    >

                        <span className="button-text">Home</span>
                    </div>

                    <div
                        onClick={() => navigate('/services')}
                        className={`menubutton-icon ${location.pathname === '/services' ? 'active' : ''}`}
                        title="services"
                    >

                        <span className="button-text">Services</span>
                    </div>

                    <div
                        onClick={() => navigate('/support')}
                        className={`menubutton-icon ${location.pathname === '/support' ? 'active' : ''}`}
                        title="about"
                    >

                        <span className="button-text">Support</span>
                    </div>
                </div>
                <div className='search-body'>
                    {/* <input className='search_input' onKeyDown={enter_search} value={search} maxLength={100} onChange={(e) => setSearch(e.target.value)} placeholder='Search Home'></input>

                    <div className='search_btn_div'>
                        <MdSearch className='search_btn' onClick={(e) => create_search()} />
                    </div> */}

                </div>

                <div className="right_body">
          <div className='itemdiv' onClick={() => navigate('/search')}>

                        <IoSearchOutline className='search_icon' /></div>
                    <div className='itemdiv' onClick={() => navigate('/search')}>
                      <MdOutlineFavoriteBorder className='search_icon' /> 
                    </div> 
                    <div className='itemdiv' onClick={() => navigate('/chart')}>
                        <Chartshow /></div>
                        
                    <div className='itemdiv' onClick={() => navigate('/services')}> 
                        <MdApps className='search_icon' /></div>

                    {userlogin ? (
                        <div className='account-sttings' onClick={() => navigate('/account')}>
                            <img src={Photosicon} className='Photos-icon' />
                        </div>
                    ) : (
                        <div className='itemdiv'>
                            <div className='button-ui2' onClick={() => navigate('/login')} >    <RiAccountCircleLine className="icon" />Login</div>
                        </div>
                    )}

                    {/* <div className='itemdiv' onClick={() => navigate('/message')}>
                                <Messageshow /></div>   */}



                </div>

            </div>
        </div>
    );
}